/**
 * True when the hostname is exactly the reserved `admin.<apex>` subdomain
 * (case-insensitive). Used to land the admin subdomain's root on the /admin
 * panel. `admin` is already in {@link RESERVED_SUBDOMAINS}, so this host is
 * treated as the apex for project-slug purposes.
 */
export function isAdminSubdomain(hostname: string, apex: string): boolean {
  if (!hostname || !apex) return false;
  return hostname.toLowerCase() === `admin.${apex.toLowerCase()}`;
}
